// @flow
import styled, { css } from "styled-components";
import { RichText as PrismicRichText } from "prismic-reactjs";
import { media } from "@nested/brand";
import {
  H2Styles,
  H3Styles,
  H4Styles,
  H6Styles,
  PStyles,
  AStyles,
  BStyles,
} from "@nested/brand/src/components/RichText/styles";

const RichTextStylesCraig = styled.div`
  ${({ center }) =>
    center &&
    css`
      * {
        margin-left: auto;
        margin-right: auto;
        text-align: center !important;
      }
    `};

  h1 {
    ${H2Styles};
    text-align: left;
    ${media.tablet`
      margin: 40px 0;
    `}
  }

  h2,
  h2 strong {
    ${H3Styles};
    text-align: left;
    ${media.tablet`
      margin: 20px 0;
    `}
  }

  h3 {
    ${H4Styles};
    text-align: left;
  }

  h4 {
    ${H6Styles};
    text-align: left;
  }

  h6 {
    ${H6Styles};
    text-align: left;
  }

  p {
    ${PStyles};
    text-align: left;
  }

  a {
    ${AStyles};
  }
  li {
    ${PStyles}
    text-align: left;
  }

  strong {
    ${BStyles};
  }

  img {
    margin-top: 50px;
    margin-bottom: 50px;
    max-width: 100%;
  }
`;

type Props = {
  children: PrismicRichText,
  center?: boolean,
};

export const PlainText = ({ children }: Props) =>
  PrismicRichText.asText(children);

export const RichText = ({ children, center }: Props) => (
  <RichTextStylesCraig center={center}>
    {PrismicRichText.render(children)}
  </RichTextStylesCraig>
);
